module.exports = __webpack_public_path__ + "media/assets/icons/facebookIconWhite-353fde44222269b142d29207132e670c.png";